// src/views/admin/clients/index.jsx
import { useToast } from '@chakra-ui/react';
import AdminPageShell from '../../../components/layout/AdminPageShell';
import { columnsDataClients } from './variables/columnsDataServicesList.js';
import React, { useEffect, useState } from 'react';
import { getData } from '../../../utils/httpClient.js';
import { useSearch } from '../../../contexts/SearchContext.js';
import { useResetPageOnFilterChange } from '../../../hooks/useResetPageOnFilterChange.js';
import { useTableSorting } from '../../../hooks/useTableSorting.js';
import ServiceListTable from '../../../components/ServiceList/ServiceListTable.js';
import CampaignValidationModal from '../../../components/Appointment/CampaignValidationModal.jsx';


export default function Settings() {
  const { searchQuery, startDate, endDate, resetListFilters } = useSearch();
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [showCampaignModal, setShowCampaignModal] = useState(false);
  const [vehicleCampaigns, setVehicleCampaigns] = useState([]);
  const [selectedVehicleChasis, setSelectedVehicleChasis] = useState('');
  const serviceTableRef = React.useRef();

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const toast = useToast();
  const { sorting, setSorting, sortBy, sortDir, appendSortParams } = useTableSorting();

  useResetPageOnFilterChange(setPage, page, [searchQuery, startDate, endDate, rowsPerPage, sortBy, sortDir]);

  const loadData = async () => {
    try {
      const today = (() => {
        const d = new Date();
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${y}-${m}-${day}`;
      })();
      const effectiveStart = startDate || today;
      const queryParams = new URLSearchParams({
        page: page + 1,
        limit: rowsPerPage,
        data: searchQuery || '',
        startDate: effectiveStart,
        endDate: endDate || '',
      });
      appendSortParams(queryParams);

      const response = await getData(
        `/vehicleServices?${queryParams.toString()}`,
      );
      
      setData(response?.payload?.vehicleServices || []);
      setTotalPages(Math.ceil(response?.payload?.total / rowsPerPage));
    } catch (error) {
      toast({
        title: 'Error al obtener servicios',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    loadData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, searchQuery, startDate, endDate, rowsPerPage, sortBy, sortDir]);

  useEffect(() => {
    resetListFilters({ resetDates: true });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const validateVehicleCampaigns = async (chassisNumber) => {
    try {
      const response = await getData(`/campaigns/vehicle/${chassisNumber}`);
      
      if (response.payload && response.payload.campaigns.length > 0) {
        setVehicleCampaigns(response.payload.campaigns);
        setSelectedVehicleChasis(chassisNumber);
        
        // Si hay campañas sin revisar, mostrar el modal
        if (response.payload.unreviewedCount > 0) {
          setShowCampaignModal(true);
          return true; // Indica que hay campañas sin revisar
        }
      }
      return false; // No hay campañas sin revisar
    } catch (error) {
      // No mostrar error al usuario ya que no es crítico para el flujo
      console.log('Error al validar campañas:', error);
      return false;
    }
  };

  const handleCampaignModalClose = () => {
    setShowCampaignModal(false);
    // Notificar a la tabla para que abra el modal de edición con el servicio ya seleccionado
    if (serviceTableRef.current) {
      serviceTableRef.current.openEditModalDirectly();
    }
  };


  return (
    <AdminPageShell
      title="Listado de servicios"
      
    >
      <ServiceListTable
          ref={serviceTableRef}
          columnsData={columnsDataClients}
          data={data}
          setData={setData}
          page={page}
          setPage={setPage}
          totalPages={totalPages}
          pageSize={rowsPerPage}
          setPageSize={setRowsPerPage}
          onValidateCampaigns={validateVehicleCampaigns}
          sorting={sorting}
          onSortingChange={setSorting}
        />

      
      <CampaignValidationModal
        isOpen={showCampaignModal}
        onClose={handleCampaignModalClose}
        campaigns={vehicleCampaigns}
        chassisNumber={selectedVehicleChasis}
      />
    </AdminPageShell>
  );
}
